// src/store/authStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Auth Store using Zustand
 * Manages user authentication state globally
 */
const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: null,
      userProfile: null,
      role: null,
      isProvisioned: false,
      
      // Actions
      setUser: (user) => set({ user }),
      
      setUserProfile: (userProfile) => set({ 
        userProfile,
        isProvisioned: true,
      }),
      
      setRole: (role) => set({ role }),
      
      clearAuth: () => set({ 
        user: null, 
        userProfile: null, 
        role: null,
        isProvisioned: false,
      }),
      
      // Getters
      getRole: () => get().role,
      isAuthenticated: () => !!get().user,
      hasRole: (requiredRole) => {
        const currentRole = get().role;
        return currentRole === requiredRole;
      },
      hasAnyRole: (requiredRoles = []) => {
        const currentRole = get().role;
        return requiredRoles.includes(currentRole);
      },
    }),
    {
      name: 'farmciti-auth', // localStorage key
      partialize: (state) => ({ 
        userProfile: state.userProfile,
        role: state.role,
        isProvisioned: state.isProvisioned,
      }),
    }
  )
);

export default useAuthStore;
